import { render } from "./GenericInput.vue?vue&type=template&id=940bf56c&scoped=true&ts=true"
import script from "./GenericInput.vue?vue&type=script&lang=ts"
export * from "./GenericInput.vue?vue&type=script&lang=ts"

import "./GenericInput.vue?vue&type=style&index=0&id=940bf56c&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940bf56c"]])

export default __exports__